/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Payment method chosen by the user (cash or online)
 */
export enum SessionPaymentMethod {
  cash = 'cash',
  online = 'online'
}
